import { Helmet } from "react-helmet-async";

export function PageMeta({ title, description, path }) {
    const url = typeof window !== "undefined" ? window.location.origin + (path || "") : "";
    return (
        <Helmet>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            <meta property="og:title" content={title} />
            {description && <meta property="og:description" content={description} />}
            {url && <link rel="canonical" href={url} />}
            {url && <meta property="og:url" content={url} />}
        </Helmet>
    );
}
